<template>
  <div class="w-full lg:w-3/4 xl:w-3/5">
    <div class="mfa-section-email-validation">
      <div class="flex mb-4 items-center">
        <div class="w-1/4">
          <slot name="svg"></slot>
        </div>
        <div class="w-3/4 px-3">
          <slot name="header"></slot>
          <slot name="subtitle"></slot>
        </div>
      </div>
      <div class="flex mb-2">
        <div class="w-full">
          <slot name="form"> </slot>
          <slot name="submitButtons"> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mfaTemplate",
};
</script>

<style lang="scss" scoped>
@import "./mfa.scss";
</style>